import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { resetBlock, initBlock } from './cellcomEnergySlice';

//pages
import AddressPage from './Pages/AddressPage';
import LeadPage from './Pages/LeadPage';
import SuccessPage from './Pages/SuccessPage';
import ErrorPage from './Pages/ErrorPage';

const CellcomEnergy = (props) => {
  let currentView = null;

  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initBlock({iContent: props.iContent});
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  useClearStateResetFlag();
  //--------------- useEffect ---------------

  switch (props.page) {
    case 'addressPage': currentView = <AddressPage />; break;
    case 'leadPage': currentView = <LeadPage />; break;  
    case 'successPage': currentView = <SuccessPage />; break; 
    case 'errorPage': currentView = <ErrorPage />; break;       
  }

  return (
    <div className='cellcom-energy-block'>
        <form noValidate id='form-cellcom-energy' onSubmit={handleSubmit}>
          {currentView}
        </form>
    </div>
  );

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    page: state.cellcomEnergyBlock.page
  };
};

const mapDispatchToProps = { 
  resetBlock,
  initBlock 
};

export default connect(mapStateToProps, mapDispatchToProps)(CellcomEnergy);
